import React, { useEffect, useMemo, useState } from "react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  const clamped = Math.max(0, t);
  return {
    days: Math.floor(clamped / 86400000),
    hrs: Math.floor((clamped / 3600000) % 24),
    min: Math.floor((clamped / 60000) % 60),
    sec: Math.floor((clamped / 1000) % 60),
  };
}

export default function Countdown({ target }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const cells = useMemo(
    () => [
      { v: t.days, l: "Days" },
      { v: t.hrs, l: "Hrs" },
      { v: t.min, l: "Min" },
      { v: t.sec, l: "Sec" },
    ],
    [t]
  );

  return (
    <div className="flex items-end gap-3">
      {cells.map((c) => (
        <div key={c.l} className="text-center">
          <div className="bg-black/80 border border-white/15 rounded-md w-[52px] h-[52px] md:w-[58px] md:h-[58px] flex items-center justify-center">
            <span className="font-display text-2xl md:text-3xl text-white tabular-nums">
              {String(c.v).padStart(2, "0")}
            </span>
          </div>
          <span className="mt-1.5 block text-[10px] uppercase tracking-[0.16em] text-white/50">
            {c.l}
          </span>
        </div>
      ))}
    </div>
  );
}
